export class ServerResponseError extends Error {
	/**
	 * Creates a new Error of type ServerResponseError.
	 * @param {string} message - The error message.
	 * @param {object} [options] - Additional options for the error. [default={}]
	 * @param {number} [options.statusCode] - HTTP status code.
	 * @param {unknown} [options.response] - The server response.
	 * @param {unknown} [options.cause] - The cause of the error.
	 */
	constructor(message, options = {}) {
		super(message, { cause: options.cause });
		this.name = "ServerResponseError";
		this.statusCode = options.statusCode;
		this.response = options.response;
	}
}
